<template>
  <div class="content income-cost-confirm-list">
    <section style="margin-bottom: 1%">
      <a-button type="primary" @click="handleCreate">
        <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
        {{ $t('新增') }}
      </a-button>
    </section>
    <div class="form-content">
      <a-row :gutter="16" style="margin-top: 15px">
        <a-col :span="6">
          <CommonSelect
            :isBu="true"
            :list="$store.state.settlementBuList"
            :placeholder="$t('结算组织')"
            :code.sync="formData.businessUnitCode"
            @change="searchHandle(1)"
          />
        </a-col>
        <a-col :span="6">
          <a-input
            allow-clear
            v-model.trim="formData.orderSn"
            :placeholder="$t('请输入单据编号')"
          />
        </a-col>
        <a-col :span="6">
          <a-input
            allow-clear
            v-model.trim="formData.sourceCode"
            :placeholder="$t('请输入来源编码')"
          />
        </a-col>
        <a-col :span="6">
          <a-select
            allow-clear
            v-model="formData.sourceType"
            :placeholder="$t('来源类型')"
            style="width: 100%"
          >
            <a-select-option
              v-for="item in $store.state.source_order_type"
              :key="item.code"
              :value="item.code"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row :gutter="16" style="margin-top: 12px">
        <a-col :span="6">
          <date-range-picker
            :needhms="false"
            @get_date="chooseAccountingDate"
            :placeholder="$t('记账日期')"
            :start-time="formData.accountingDateStart"
            :end-time="formData.accountingDateEnd"
          />
        </a-col>
        <a-col :span="6">
          <a-select
            v-model="formData.needGenerateVoucher"
            allow-clear
            :placeholder="$t('能否生成凭证')"
            style="width: 100%"
          >
            <a-select-option :value="1">{{ $t('需要') }}</a-select-option>
            <a-select-option :value="0">{{ $t('不需要') }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6">
          <a-select
            v-model="formData.voucherGenerated"
            allow-clear
            :placeholder="$t('已生成凭证')"
            style="width: 100%"
          >
            <a-select-option :value="1">{{ $t('是') }}</a-select-option>
            <a-select-option :value="0">{{ $t('否') }}</a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row :gutter="16" class="mt10">
        <a-col :span="6">
          <a-button @click="searchHandle(1)" type="primary">
            <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
            {{ $t('查询') }}
          </a-button>
          <a-button @click="reset" style="margin-left: 8px">
            <a-icon type="redo" />
            {{ $t('重置') }}
          </a-button>
        </a-col>
      </a-row>
    </div>

    <!-- 状态 Tab 筛选 -->
    <!-- <a-tabs v-model="formData.status" class="mt10" @change="changeTab">
        <a-tab-pane key="" :tab="$t('全部')" />
        <a-tab-pane
          v-for="item in income_cost_confirm_order_status"
          :key="item.code"
          :tab="item.name"
        />
      </a-tabs> -->

    <CommonTable
      class="mt10"
      ref="CommonTableRef"
      :statusList="income_cost_confirm_order_status"
      :showSelect="true"
      :selectedRowKeys.sync="selectedRowKeys"
      :selectedRows.sync="selectedRows"
      :scroll="{ x: 1800, y: scrollHeight }"
      :loading="tableLoading"
      :columns.sync="tableColumns"
      :data-source="tableData"
      :total="total"
      rowKey="id"
      @select="onSelectChange"
      @search="queryOrderList"
    >
      <template v-slot:header>
        <div class="flex-ct gap10">
          <OperateBtn
            api="operateDoc"
            :text="$t('提交')"
            :params="{
              action: 'commit',
              docType: 'IncomeCostConfirmOrder',
              idList: selectedRowKeys,
            }"
            :disabled="selectedRowKeys.length === 0"
            @success="searchHandle"
          />
          <OperateBtn
            api="operateDoc"
            :text="$t('审核')"
            :params="{
              action: 'check',
              docType: 'IncomeCostConfirmOrder',
              idList: selectedRowKeys,
            }"
            :disabled="selectedRowKeys.length === 0"
            @success="searchHandle"
          />
          <a-button
            type="danger"
            :disabled="selectedRowKeys.length === 0"
            :loading="batchCancelLoading"
            @click="confirmBatchCancel"
          >
            {{ $t('作废') }}
          </a-button>
          <VoucherBtn
            :doc-type="docType"
            :selected-rows="selectedRows"
            :disabled="selectedRowKeys.length === 0"
            @close="searchHandle"
          />
        </div>
      </template>
      <!-- 单据编号 -->
      <template v-slot:orderSn="{ text, record }">
        <a @click="viewDetail(record)">{{ text }}</a>
      </template>
      <!-- 来源编码 -->
      <template v-slot:sourceCode="{ record }">
        <span>{{ record.sourceCode }}</span>
      </template>
      <!-- 总金额 -->
      <template v-slot:totalAmount="{ text, record }">
        <PriceInput :value="text" :showTxt="true" :currency="record.settlementCurrency" />
      </template>
      <!-- 未税金额 -->
      <template v-slot:totalAmountWithoutTax="{ text, record }">
        <PriceInput :value="text" :showTxt="true" :currency="record.settlementCurrency" />
      </template>
      <!-- 税额 -->
      <template v-slot:taxAmount="{ text, record }">
        <PriceInput :value="text" :showTxt="true" :currency="record.settlementCurrency" />
      </template>
    </CommonTable>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import dateRangePicker from '@component/dateRangePicker'
import PriceInput from '@component/priceInput'
import { convertKeysToCamelCase, spaceToComma, fetchDocumentMappings } from '@/common'

export default {
  name: 'incomeCostConfirmList',
  activated() {
    this.searchHandle()
    this.fetchMappings()
  },
  components: {
    dateRangePicker,
    PriceInput,
  },
  data() {
    return {
      docType: 'IncomeCostConfirmOrder',
      formData: {
        orderSn: undefined,
        sourceCode: undefined,
        sourceType: undefined,
        businessUnitCode: undefined,
        accountingDateStart: undefined,
        accountingDateEnd: undefined,
        status: '',
        needGenerateVoucher: undefined,
        voucherGenerated: undefined,
      },
      tableLoading: false,
      total: 0,
      selectedRowKeys: [],
      selectedRows: [],
      tableData: [],
      mappings: {
        orderType: {},
      },
      batchCancelLoading: false,
    }
  },
  computed: {
    ...mapState([
      'income_cost_confirm_status',
      'income_cost_confirm_order_status',
      'source_order_type',
    ]),
    ...mapGetters(['incomeCostConfirmOrderTypeMapping', 'incomeCostConfirmOrderStatusMapping']),
    scrollHeight() {
      return window.innerHeight - 470
    },
    tableColumns() {
      return [
        {
          dataIndex: 'orderSn',
          title: this.$t('单据编号'),
          key: 'orderSn',
          width: 200,
          scopedSlots: { customRender: 'orderSn' },
        },
        {
          title: this.$t('状态'),
          dataIndex: 'status',
          width: 120,
          customRender: (text) => this.incomeCostConfirmOrderStatusMapping[text],
        },
        {
          title: this.$t('结算组织'),
          dataIndex: 'businessUnitName',
          width: 150,
        },
        {
          title: this.$t('单据类型'),
          dataIndex: 'orderType',
          width: 130,
          customRender: (text) => this.mappings.orderType[text] || text,
        },
        {
          title: this.$t('来源名称'),
          dataIndex: 'sourceName',
          width: 180,
        },
        {
          title: this.$t('记账日期'),
          dataIndex: 'accountingDate',
          width: 150,
        },
        {
          title: this.$t('业务时间'),
          dataIndex: 'bizDate',
          width: 180,
          customRender: (text) => text?.split(' ')[0],
        },
        {
          title: this.$t('开始日期'),
          dataIndex: 'startDate',
          width: 130,
          customRender: (text) => text?.split(' ')[0],
        },
        {
          title: this.$t('结束日期'),
          dataIndex: 'endDate',
          width: 130,
          customRender: (text) => text?.split(' ')[0],
        },
        {
          title: this.$t('总金额'),
          dataIndex: 'totalAmount',
          width: 130,
          scopedSlots: { customRender: 'totalAmount' },
        },
        {
          title: this.$t('未税金额'),
          dataIndex: 'totalAmountWithoutTax',
          width: 130,
          scopedSlots: { customRender: 'totalAmountWithoutTax' },
        },
        {
          title: this.$t('税额'),
          dataIndex: 'taxAmount',
          width: 130,
          scopedSlots: { customRender: 'taxAmount' },
        },
        {
          title: this.$t('税率') + '(%)',
          dataIndex: 'taxRate',
          width: 100,
        },
        {
          title: this.$t('能否生成凭证'),
          dataIndex: 'needGenerateVoucher',
          width: 120,
          customRender: (text, record) => {
            const val = record.needGenerateVoucher ?? record.need_generate_voucher
            return val === 1 ? this.$t('需要') : val === 0 ? this.$t('不需要') : ''
          },
        },
        {
          title: this.$t('是否生成凭证'),
          dataIndex: 'voucherGenerated',
          width: 120,
          customRender: (text) => (text ? this.$t('是') : this.$t('否')),
        },
        {
          title: this.$t('总明细行数'),
          dataIndex: 'itemCount',
          width: 120,
        },
        {
          title: this.$t('凭证号'),
          dataIndex: 'voucherNo',
          width: 120,
        },
        {
          title: this.$t('备注'),
          dataIndex: 'remark',
          width: 150,
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createdAt',
          width: 180,
        },
        {
          title: this.$t('创建人'),
          dataIndex: 'createdUser',
          width: 120,
        },
        {
          title: this.$t('审核时间'),
          dataIndex: 'checkTime',
          width: 180,
        },
      ]
    },
  },
  methods: {
    ...mapMutations(['addPane']),
    handleCreate() {
      this.addPane({
        view: 'receivableManage/incomeCostConfirmDetail',
        name: 'detailSn',
        route: '/receivableManage/incomeCostConfirmDetail',
      })
    },
    async fetchMappings() {
      this.mappings = await fetchDocumentMappings(this.docType, ['orderType'])
    },
    reset() {
      const mappings = this.mappings
      Object.assign(this.$data, this.$options.data.call(this))
      this.mappings = mappings
      this.searchHandle(1)
    },
    searchHandle(pageNo) {
      this.selectedRowKeys = []
      this.selectedRows = []
      this.$refs.CommonTableRef.queryList(pageNo)
    },
    changeTab(status) {
      this.formData.status = status
      this.searchHandle(1)
    },
    viewDetail(record) {
      this.addPane({
        view: 'receivableManage/incomeCostConfirmDetail/' + record.orderSn,
        name: 'detailSn',
        query: {
          id: record.id,
          sn: record.orderSn,
        },
        route: `/receivableManage/incomeCostConfirmDetail?id=${record.id}&sn=${record.orderSn}`,
      })
    },
    chooseAccountingDate(date) {
      this.formData.accountingDateStart = date.start_time
      this.formData.accountingDateEnd = date.end_time
    },
    async queryOrderList(params) {
      if (!this.formData.businessUnitCode) return
      let data = {
        ...this.formData,
        ...params,
      }
      let orderSn = spaceToComma(this.formData.orderSn || '')
      if (orderSn.includes(',')) {
        data.orderSn = orderSn.split(',')[0]
      } else if (orderSn) {
        data.orderSn = orderSn
      }
      this.tableLoading = true
      let res = await http({
        type: 'post',
        url: api.getIncomeCostConfirmList,
        data,
      })
      this.tableData = convertKeysToCamelCase(res.result.list || [])
      this.total = res.result.total
      this.tableLoading = false
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    confirmBatchCancel() {
      const invalidRows = this.selectedRows.filter(
        (row) => !['DRAFT', 'WAIT_CHECK'].includes(row.status)
      )
      if (invalidRows.length > 0) {
        this.$message.warning(this.$t('只有草稿和待审核状态的单据可以作废'))
        return
      }

      this.$confirm({
        title: this.$t('确认操作'),
        content: `${this.$t('是否确认作废已选中的')} ${this.selectedRowKeys.length} ${this.$t(
          '个单据'
        )}？`,
        onOk: () => this.batchCancel(),
      })
    },
    async batchCancel() {
      this.batchCancelLoading = true
      try {
        const promises = this.selectedRowKeys.map((id) =>
          http({
            url: api.operateDoc,
            data: {
              action: 'cancel',
              docType: this.docType,
              idList: [id],
            },
          })
        )
        await Promise.all(promises)
        this.$success({
          title: this.$t('成功'),
          content: this.$t('作废成功'),
        })
        this.searchHandle()
      } catch (err) {
        this.searchHandle()
      } finally {
        this.batchCancelLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@css/mixin.scss';
</style>
